import { useContext } from 'react';
import ShellRootContext from './ShellRootContext';

const useShellRootContext = () => useContext(ShellRootContext);

export default useShellRootContext;
